import tenantFilters from '@tenantFilters';
import getAddInterestFilters from './add-interest-fitlers';
import getCreditsUsageFilters from './creditsUsageFilters';
import getLeadsStaffFilters from './leads-staff-filters';
import getLeadsReportsFilters from './leadsReportsFilters';
import getMyListingsFilters from './listingFilters';
import getQuotaCreditsFilters from './quotaCreditsFilters';
import getAdLicenseFilters from './adLicenseFilters';

let filters = {
  getCreditsUsageFilters,
  getLeadsReportsFilters,
  getMyListingsFilters,
  getLeadsStaffFilters,
  getAddInterestFilters,
  getQuotaCreditsFilters,
  getAdLicenseFilters,
  ...tenantFilters,
};
export default filters;
